import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <ConditionalLoadingSpinner @condition={{this.loading}}>
  <LoadMore
    @selector=".bookmark-list .bookmark-list-item"
    @action={{this.loadMore}}
  >
    <table class="topic-list bookmark-list">
      <thead class="topic-list-header">
        {{#if this.site.desktopView}}
          <PluginOutlet @name="bookmark-list-table-header">
            {{#if this.bulkSelectEnabled}}
              <th class="bulk-select topic-list-data">
                <FlatButton
                  @action={{this.toggleBulkSelect}}
                  @class="bulk-select"
                  @icon="tasks"
                  @title="bookmarks.bulk.toggle"
                />
              </th>
            {{/if}}
            <th class="topic-list-data">

              {{#if this.bulkSelectEnabled}}
                <span class="bulk-select-topics">
                  {{~#if this.canDoBulkActions}}
                    <div class="bulk-select-bookmarks-dropdown">
                      <span class="bulk-select-bookmark-dropdown__count">
                        {{i18n
                          "bookmarks.bulk.selected_count"
                          count=this.selectedCount
                        }}
                      </span>
                      <BulkSelectBookmarksDropdown
                        @bulkSelectHelper={{this.bulkSelectHelper}}
                      />
                    </div>

                  {{/if~}}
                  <DButton
                    @action={{this.selectAll}}
                    class="btn btn-default bulk-select-all"
                    @label="bookmarks.bulk.select_all"
                  />
                  <DButton
                    @action={{this.clearAll}}
                    class="btn btn-default bulk-clear-all"
                    @label="bookmarks.bulk.clear_all"
                  />
                </span>
              {{else}}
                <FlatButton
                  @action={{this.toggleBulkSelect}}
                  @class="bulk-select"
                  @icon="tasks"
                  @title="bookmarks.bulk.toggle"
                />
                {{i18n "topic.title"}}
              {{/if~}}
            </th>
            <th class="topic-list-data">&nbsp;</th>
            <th class="post-metadata topic-list-data">{{i18n
                "post.bookmarks.updated"
              }}</th>
            <th class="post-metadata topic-list-data">{{i18n "activity"}}</th>
            <th>&nbsp;</th>
          </PluginOutlet>
        {{/if}}
      </thead>
      <tbody class="topic-list-body">
        {{#each this.content as |bookmark|}}
          <tr class="topic-list-item bookmark-list-item">
            {{#if this.bulkSelectEnabled}}
              <td class="bulk-select bookmark-list-data">
                <label for="bulk-select-{{bookmark.id}}">
                  <input
                    type="checkbox"
                    class="bulk-select"
                    id="bulk-select-{{bookmark.id}}"
                    data-id={{bookmark.id}}
                  />
                </label>
              </td>
            {{/if}}
            <th scope="row" class="main-link topic-list-data">
              <span class="link-top-line">
                <div class="bookmark-metadata">
                  {{#if bookmark.reminder_at}}
                    <span
                      class="bookmark-metadata-item bookmark-reminder
                        {{if
                          bookmark.reminderAtExpired
                          'bookmark-expired-reminder'
                        }}"
                    >
                      {{d-icon "far-clock"}}{{bookmark.formattedReminder}}
                    </span>
                  {{/if}}
                  {{#if bookmark.name}}
                    <span class="bookmark-metadata-item">
                      {{d-icon "info-circle"}}<span>{{bookmark.name}}</span>
                    </span>
                  {{/if}}
                </div>
                <div class="bookmark-status-with-link">
                  {{#if bookmark.pinned}}
                    {{d-icon "thumbtack" class="bookmark-pinned"}}
                  {{/if}}
                  {{#if bookmark.bookmarkableTopicAlike}}
                    <TopicStatus @topic={{bookmark.topicStatus}} />
                    {{topic-link bookmark.topicForList}}
                  {{else}}
                    <a
                      href={{bookmark.bookmarkable_url}}
                      role="heading"
                      aria-level="2"
                      class="title"
                      data-topic-id="${topic.id}"
                    >
                      {{bookmark.fancy_title}}
                    </a>
                  {{/if}}
                </div>
              </span>
              {{#if bookmark.bookmarkableTopicAlike}}
                <div class="link-bottom-line">
                  {{category-link bookmark.category}}
                  {{discourse-tags
                    bookmark
                    mode="list"
                    tagsForUser=this.tagsForUser
                  }}
                </div>
              {{/if}}
              {{#if
                (and
                  this.site.mobileView
                  bookmark.excerpt
                  bookmark.user.avatar_template
                )
              }}
                <a
                  href={{bookmark.bookmarkableUser.path}}
                  data-user-card={{bookmark.user.username}}
                  class="avatar"
                >
                  {{avatar
                    bookmark.bookmarkableUser
                    avatarTemplatePath="avatar_template"
                    usernamePath="username"
                    namePath="name"
                    imageSize="small"
                  }}
                </a>
              {{/if}}

              {{! template-lint-disable no-invalid-interactive }}
              <p
                class="post-excerpt"
                {{on "click" this.screenExcerptForExternalLink}}
              >{{html-safe bookmark.excerpt}}</p>
            </th>
            {{#if this.site.desktopView}}
              <td class="author-avatar topic-list-data">
                {{#if bookmark.user.avatar_template}}
                  <a
                    href={{bookmark.user.path}}
                    data-user-card={{bookmark.user.username}}
                    class="avatar"
                  >
                    {{avatar
                      bookmark.user
                      avatarTemplatePath="avatar_template"
                      usernamePath="username"
                      namePath="name"
                      imageSize="small"
                    }}
                  </a>
                {{/if}}
              </td>
              <td class="post-metadata topic-list-data updated-at">{{format-date
                  bookmark.updated_at
                  format="tiny"
                }}</td>
              {{raw
                "list/activity-column"
                topic=bookmark
                class="num post-metadata"
                tagName="td"
              }}
            {{/if}}
            <td class="topic-list-data">
              <BookmarkActionsDropdown
                @bookmark={{bookmark}}
                @removeBookmark={{action "removeBookmark"}}
                @editBookmark={{action "editBookmark"}}
                @clearBookmarkReminder={{action "clearBookmarkReminder"}}
                @togglePinBookmark={{action "togglePinBookmark"}}
              />
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
    <ConditionalLoadingSpinner @condition={{this.loadingMore}} />
  </LoadMore>
</ConditionalLoadingSpinner>
*/
{
  "id": "tXUYJW27",
  "block": "[[[8,[39,0],null,[[\"@condition\"],[[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@selector\",\"@action\"],[\".bookmark-list .bookmark-list-item\",[30,0,[\"loadMore\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[10,\"table\"],[14,0,\"topic-list bookmark-list\"],[12],[1,\"\\n      \"],[10,\"thead\"],[14,0,\"topic-list-header\"],[12],[1,\"\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"          \"],[8,[39,3],null,[[\"@name\"],[\"bookmark-list-table-header\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"bulkSelectEnabled\"]],[[[1,\"              \"],[10,\"th\"],[14,0,\"bulk-select topic-list-data\"],[12],[1,\"\\n                \"],[8,[39,4],null,[[\"@action\",\"@class\",\"@icon\",\"@title\"],[[30,0,[\"toggleBulkSelect\"]],\"bulk-select\",\"tasks\",\"bookmarks.bulk.toggle\"]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,\"th\"],[14,0,\"topic-list-data\"],[12],[1,\"\\n\\n\"],[41,[30,0,[\"bulkSelectEnabled\"]],[[[1,\"                \"],[10,1],[14,0,\"bulk-select-topics\"],[12],[41,[30,0,[\"canDoBulkActions\"]],[[[1,\"                    \"],[10,0],[14,0,\"bulk-select-bookmarks-dropdown\"],[12],[1,\"\\n                      \"],[10,1],[14,0,\"bulk-select-bookmark-dropdown__count\"],[12],[1,\"\\n                        \"],[1,[28,[35,5],[\"bookmarks.bulk.selected_count\"],[[\"count\"],[[30,0,[\"selectedCount\"]]]]]],[1,\"\\n                      \"],[13],[1,\"\\n                      \"],[8,[39,6],null,[[\"@bulkSelectHelper\"],[[30,0,[\"bulkSelectHelper\"]]]],null],[1,\"\\n                    \"],[13],[1,\"\\n\\n\"]],[]],null],[8,[39,7],[[24,0,\"btn btn-default bulk-select-all\"]],[[\"@action\",\"@label\"],[[30,0,[\"selectAll\"]],\"bookmarks.bulk.select_all\"]],null],[1,\"\\n                  \"],[8,[39,7],[[24,0,\"btn btn-default bulk-clear-all\"]],[[\"@action\",\"@label\"],[[30,0,[\"clearAll\"]],\"bookmarks.bulk.clear_all\"]],null],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],[[[1,\"                \"],[8,[39,4],null,[[\"@action\",\"@class\",\"@icon\",\"@title\"],[[30,0,[\"toggleBulkSelect\"]],\"bulk-select\",\"tasks\",\"bookmarks.bulk.toggle\"]],null],[1,\"\\n                \"],[1,[28,[35,5],[\"topic.title\"],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n            \"],[10,\"th\"],[14,0,\"topic-list-data\"],[12],[1,\" \"],[13],[1,\"\\n            \"],[10,\"th\"],[14,0,\"post-metadata topic-list-data\"],[12],[1,[28,[35,5],[\"post.bookmarks.updated\"],null]],[13],[1,\"\\n            \"],[10,\"th\"],[14,0,\"post-metadata topic-list-data\"],[12],[1,[28,[35,5],[\"activity\"],null]],[13],[1,\"\\n            \"],[10,\"th\"],[12],[1,\" \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,\"tbody\"],[14,0,\"topic-list-body\"],[12],[1,\"\\n\"],[42,[28,[37,9],[[28,[37,9],[[30,0,[\"content\"]]],null]],null],null,[[[1,\"          \"],[10,\"tr\"],[14,0,\"topic-list-item bookmark-list-item\"],[12],[1,\"\\n\"],[41,[30,0,[\"bulkSelectEnabled\"]],[[[1,\"              \"],[10,\"td\"],[14,0,\"bulk-select bookmark-list-data\"],[12],[1,\"\\n                \"],[10,\"label\"],[15,\"for\",[29,[\"bulk-select-\",[30,1,[\"id\"]]]]],[12],[1,\"\\n                  \"],[10,\"input\"],[14,0,\"bulk-select\"],[15,1,[29,[\"bulk-select-\",[30,1,[\"id\"]]]]],[15,\"data-id\",[30,1,[\"id\"]]],[14,4,\"checkbox\"],[12],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,\"th\"],[14,\"scope\",\"row\"],[14,0,\"main-link topic-list-data\"],[12],[1,\"\\n              \"],[10,1],[14,0,\"link-top-line\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"bookmark-metadata\"],[12],[1,\"\\n\"],[41,[30,1,[\"reminder_at\"]],[[[1,\"                    \"],[10,1],[15,0,[29,[\"bookmark-metadata-item bookmark-reminder\\n                        \",[52,[30,1,[\"reminderAtExpired\"]],\"bookmark-expired-reminder\"]]]],[12],[1,\"\\n                      \"],[1,[28,[35,10],[\"far-clock\"],null]],[1,[30,1,[\"formattedReminder\"]]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"name\"]],[[[1,\"                    \"],[10,1],[14,0,\"bookmark-metadata-item\"],[12],[1,\"\\n                      \"],[1,[28,[35,10],[\"info-circle\"],null]],[10,1],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n                \"],[10,0],[14,0,\"bookmark-status-with-link\"],[12],[1,\"\\n\"],[41,[30,1,[\"pinned\"]],[[[1,\"                    \"],[1,[28,[35,10],[\"thumbtack\"],[[\"class\"],[\"bookmark-pinned\"]]]],[1,\"\\n\"]],[]],null],[41,[30,1,[\"bookmarkableTopicAlike\"]],[[[1,\"                    \"],[8,[39,11],null,[[\"@topic\"],[[30,1,[\"topicStatus\"]]]],null],[1,\"\\n                    \"],[1,[28,[35,12],[[30,1,[\"topicForList\"]]],null]],[1,\"\\n\"]],[]],[[[1,\"                    \"],[10,3],[15,6,[30,1,[\"bookmarkable_url\"]]],[14,\"role\",\"heading\"],[14,\"aria-level\",\"2\"],[14,0,\"title\"],[14,\"data-topic-id\",\"${topic.id}\"],[12],[1,\"\\n                      \"],[1,[30,1,[\"fancy_title\"]]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]]],[1,\"                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"],[41,[30,1,[\"bookmarkableTopicAlike\"]],[[[1,\"                \"],[10,0],[14,0,\"link-bottom-line\"],[12],[1,\"\\n                  \"],[1,[28,[35,13],[[30,1,[\"category\"]]],null]],[1,\"\\n                  \"],[1,[28,[35,14],[[30,1]],[[\"mode\",\"tagsForUser\"],[\"list\",[30,0,[\"tagsForUser\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[37,15],[[30,0,[\"site\",\"mobileView\"]],[30,1,[\"excerpt\"]],[30,1,[\"user\",\"avatar_template\"]]],null],[[[1,\"                \"],[10,3],[15,6,[30,1,[\"bookmarkableUser\",\"path\"]]],[15,\"data-user-card\",[30,1,[\"user\",\"username\"]]],[14,0,\"avatar\"],[12],[1,\"\\n                  \"],[1,[28,[35,16],[[30,1,[\"bookmarkableUser\"]]],[[\"avatarTemplatePath\",\"usernamePath\",\"namePath\",\"imageSize\"],[\"avatar_template\",\"username\",\"name\",\"small\"]]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"              \"],[11,2],[24,0,\"post-excerpt\"],[4,[38,17],[\"click\",[30,0,[\"screenExcerptForExternalLink\"]]],null],[12],[1,[28,[35,18],[[30,1,[\"excerpt\"]]],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"              \"],[10,\"td\"],[14,0,\"author-avatar topic-list-data\"],[12],[1,\"\\n\"],[41,[30,1,[\"user\",\"avatar_template\"]],[[[1,\"                  \"],[10,3],[15,6,[30,1,[\"user\",\"path\"]]],[15,\"data-user-card\",[30,1,[\"user\",\"username\"]]],[14,0,\"avatar\"],[12],[1,\"\\n                    \"],[1,[28,[35,16],[[30,1,[\"user\"]]],[[\"avatarTemplatePath\",\"usernamePath\",\"namePath\",\"imageSize\"],[\"avatar_template\",\"username\",\"name\",\"small\"]]]],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[13],[1,\"\\n              \"],[10,\"td\"],[14,0,\"post-metadata topic-list-data updated-at\"],[12],[1,[28,[35,19],[[30,1,[\"updated_at\"]]],[[\"format\"],[\"tiny\"]]]],[13],[1,\"\\n              \"],[1,[28,[35,20],[\"list/activity-column\"],[[\"topic\",\"class\",\"tagName\"],[[30,1],\"num post-metadata\",\"td\"]]]],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,\"td\"],[14,0,\"topic-list-data\"],[12],[1,\"\\n              \"],[8,[39,21],null,[[\"@bookmark\",\"@removeBookmark\",\"@editBookmark\",\"@clearBookmarkReminder\",\"@togglePinBookmark\"],[[30,1],[28,[37,22],[[30,0],\"removeBookmark\"],null],[28,[37,22],[[30,0],\"editBookmark\"],null],[28,[37,22],[[30,0],\"clearBookmarkReminder\"],null],[28,[37,22],[[30,0],\"togglePinBookmark\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,0],null,[[\"@condition\"],[[30,0,[\"loadingMore\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]]]]]],[\"bookmark\"],false,[\"conditional-loading-spinner\",\"load-more\",\"if\",\"plugin-outlet\",\"flat-button\",\"i18n\",\"bulk-select-bookmarks-dropdown\",\"d-button\",\"each\",\"-track-array\",\"d-icon\",\"topic-status\",\"topic-link\",\"category-link\",\"discourse-tags\",\"and\",\"avatar\",\"on\",\"html-safe\",\"format-date\",\"raw\",\"bookmark-actions-dropdown\",\"action\"]]",
  "moduleName": "discourse/components/bookmark-list.hbs",
  "isStrictMode": false
});